// extracted by mini-css-extract-plugin
export default {"root":"Achieves_root__Zqh5D","root__item":"Achieves_root__item__WC0q+"};